export const getYearlyFsaAmount = (newWeeklyAmount, remainingPayPeriods, ytdContributions, existingWeeklyContributionAmount, remainingWeeksForExistingContributions, yearlyMax) => {
    if(!ytdContributions)
        ytdContributions = 0;
    if(!existingWeeklyContributionAmount)
        existingWeeklyContributionAmount = 0;
    if(!remainingWeeksForExistingContributions)
        remainingWeeksForExistingContributions = 0;
    
    const newYearlyAmount = newWeeklyAmount * remainingPayPeriods;
    const existingYearlyAmount = ytdContributions + (existingWeeklyContributionAmount * remainingWeeksForExistingContributions);
    const yearlyFsaAmount = newYearlyAmount + existingYearlyAmount;
    
    let amount = yearlyFsaAmount > yearlyMax ? yearlyMax : yearlyFsaAmount;

    return rounder(amount);
};

const rounder = (num) => {
    var mult = parseInt("1" + "0".repeat(2));
    num = num * mult;
    return Number(num / mult).toFixed(2);
};

const roundDown = (num) => {
    var mult = 100; // Multiplying by 100 to shift decimal places
    num = num * mult;
    return (Math.floor(num) / mult).toFixed(2);
};

export const getWeeklyFsaAmount = (newYearlyAmount, remainingPayPeriods, ytdContributions, existingWeeklyContributionAmount, remainingWeeksForExistingContributions, weeklyMax) => {

    if(!ytdContributions)
        ytdContributions = 0;
    if(!existingWeeklyContributionAmount)
        existingWeeklyContributionAmount = 0;
    if(!remainingWeeksForExistingContributions)
        remainingWeeksForExistingContributions = 0;
    
    const existingYearlyAmount = ytdContributions + (existingWeeklyContributionAmount * remainingWeeksForExistingContributions);
    const newWeeklyAmount = (newYearlyAmount - existingYearlyAmount) / remainingPayPeriods;
    let amount = newWeeklyAmount > weeklyMax ? weeklyMax : newWeeklyAmount < 0 ? 0 : newWeeklyAmount;

    return roundDown(amount);
};
